module.exports = __webpack_public_path__ + "img/17.184f817d.svg";